import React, { Component } from 'react'

let map= window.map;
let google=window.google;
export default class WhyHere extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            static_text:props.static_text
        }
    }

    _poiList = () => {

        if (this.props.data.points_of_interest != null && this.props.data.points_of_interest.length > 0) {
            return (
                this.props.data.points_of_interest.map((item, index) => {
                    if(item != ''){
                        return (
                            <li><a href="javascript:void(0)" key={"poi-" + index} > {item}</a></li>
                        )

                    }
                })
            )
        }
    }

    _envirList1 = () => {
        if (this.props.data.villa_transport != null && this.props.data.villa_transport.length > 0) {
            return (
                this.props.data.villa_transport.map((item, index) => {
                    if(item != ''){
                        return (
                            <li><a href="javascript:void(0)" key={"envir-" + index} > {item}</a></li>
                        )
                    }
                })
            )
        }
    }

    _envirList2 = () => {
        if (this.props.data.villa_accessible != null) {
            return (
                <li><a href="javascript:void(0)" key={"envir-" + this.props.data.villa_transport.length} > {this.props.data.villa_accessible}</a></li>
            )
        }
    }

    _activList = () =>{
        if (this.props.data.villa_activities != null && this.props.data.villa_activities.length > 0) {
            return (
                this.props.data.villa_activities.map((item, index) => {
                    if(item != ''){
                            return (
                                <li><a href="javascript:void(0)" key={"envir-" + index} > {item}</a></li>
                            )
                    }
                })
            )
        }
    }

    componentDidMount = () =>{
        map = new google.maps.Map(document.getElementById('mapCanvas'), {
            zoom: 8,
            center: new google.maps.LatLng(parseFloat(this.props.data.lat),parseFloat(this.props.data.lng)),
            mapTypeId: google.maps.MapTypeId.ROADMAP
          });
         let marker = new google.maps.Marker({
            position: new google.maps.LatLng(parseFloat(this.props.data.lat),parseFloat(this.props.data.lng)),
            title: this.props.data.address,
            map: map,
            draggable: true
          });
    }

    render() {

        return (
            <div id="why-her">
                <div className="row">
                    <div className="col-md-12">
                        <h2>{this.props.static_text.why_come_here_text}</h2>
                        <p>{this.props.data.why_here_text}</p>
                        <div className="row">
                            <div className="col-md-12">
                                <h6>{this.props.static_text.point_of_interest_text}</h6>
                                <ul className="blue-btn">
                                    {this._poiList()}
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <h6> {this.props.static_text.environment_going_around_text}</h6>
                                <ul className="red-btn">
                                    {this._envirList1()}
                                    {this._envirList2()}
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <div className="map-responsive mb-2">
                                <div id="mapCanvas"  style={{ "border": 0,height:"300px",width:"100%", frameBorder:"0" }} allowFullScreen ></div>
                                    {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26371331.527698696!2d-113.71729875604574!3d36.21138648158707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54eab584e432360b%3A0x1c3bb99243deb742!2sUnited%20States!5e0!3m2!1sen!2sin!4v1604661946280!5m2!1sen!2sin" width="100%" height="300" frameBorder="0" style={{ "border": 0 }} allowFullScreen></iframe> */}
                                </div>
                            </div>
                            <div className="col-md-12" id="activities">
                                <h6>{this.props.static_text.activities_text}</h6>
                                <ul className="blue-btn">
                                    {this._activList()}
                                 </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}
